<!-- Utiliza *ngIf para mostrar u ocultar el modal -->
<div *ngIf="isOpen" class="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full flex">
    <div class="relative p-4 w-full max-w-3xl max-h-full">
      <!-- Contenido del modal -->
      <div class="bg-white rounded-lg shadow-lg">
        <!-- Cabecera del modal -->
        <!-- <div class="flex items-start justify-between p-5 border-b border-solid border-neutral-300 rounded-t">
          <h3 class="text-2xl font-semibold">Título del Modal</h3>
          <button class="text-neutral-500 hover:text-gray-600 focus:outline-none" (click)="closeModal()">
            <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
          </button>
        </div> -->
        <!-- Contenido del modal -->
        <div class="p-6">
          <!-- Aquí va tu contenido dinámico del modal -->
          <ng-content></ng-content>
        </div>
        <!-- Pie del modal -->
        <div class="flex items-center justify-end p-3 border-t border-solid border-neutral-300 rounded-b">
          <button class="text-gray-500 hover:text-gray-600 mr-2 px-4 py-2 border border-neutral-300 rounded-md focus:outline-none" (click)="closeModal()">Cerrar</button>
          <!-- Otros botones o acciones -->
        </div>
      </div>
    </div>
  </div>
  <!-- Fondo oscuro para el modal -->
  <div *ngIf="isOpen" class="fixed inset-0 z-40 bg-black opacity-50"></div>
  